export default __webpack_public_path__ + "static/media/natur.9cdc2252.jpg";